import { theme } from '@/utils/theme';

export const classes = {
  formControl: 'w-full',
  iconButton:
    'hover:bg-transparent text-grey-7 hover:text-grey-9 transition-colors dark:text-mauve-2 dark:hover:text-mauve-1',
  auroraIconButton:
    'size-8 rounded-[9px] text-taupe-2 transition-colors hover:bg-black/[0.06] hover:text-taupe-3 dark:text-mauve-2 dark:hover:bg-white/[0.06] dark:hover:text-mauve-1',
  searchIcon: 'text-grey-7 dark:text-mauve-2',
  closeButton:
    'hover:bg-transparent text-grey-6 hover:text-grey-7 transition-colors dark:text-mauve-3 dark:hover:text-mauve-2',
};

export const styles = {
  formControl: {
    '& .MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: `1px solid ${theme.palette['orange-3'].main}`,
    },
    '& .MuiInputBase-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline':
      {
        transition: 'border-color 0.2s',
        borderColor: theme.palette['orange-3'].main,
      },
  },
};
